<template>
  <div class="fill-height">
    <admin-wrapper title-translation-path="navbar.appState" :has-buttons="false">
      <template #form>
        <v-form>
          <admin-input-row v-bind="devFrontBuildDateText" class="py-3">
            <template #devFrontBuildDate.input>
              <v-row no-gutters>
                <v-col cols="auto" class="text-left text-body-2">
                  {{ devFrontBuildDateValue }}
                  <v-row no-gutters>
                    <v-col cols="auto">
                      <italic-subheader translation-path="admin.lastUpdate"></italic-subheader>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </template>
          </admin-input-row>
          <admin-input-row v-bind="devFrontBuildCommitText" class="py-3">
            <template #devFrontBuildCommit.input>
              <v-row no-gutters>
                <v-col cols="auto" class="text-left text-body-2">
                  {{ devFrontBuildCommitValue }}
                  <v-row no-gutters>
                    <v-col cols="auto">
                      <v-subheader
                        class="text-caption font-italic font-weight-light pa-0"
                        style="height: auto; line-height: 1rem !important; color: inherit"
                      >
                        <a
                          :href="`https://bitbucket.org/gissupport/aquagis3-web/commits/${commitBuild}`"
                          target="_blank"
                          >commits</a
                        >
                      </v-subheader>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </template>
          </admin-input-row>
        </v-form>
      </template>
    </admin-wrapper>
  </div>
</template>

<script>
import AdminWrapper from '@/components/AdminWrapper';
import AdminInputRow from '@/components/AdminInputRow';
import ItalicSubheader from '@/components/ItalicSubheader';

export default {
  name: 'DevTab',
  components: { ItalicSubheader, AdminInputRow, AdminWrapper },
  data: () => ({
    devFrontBuildDateText: {
      name: 'devFrontBuildDate',
      translationPath: 'admin.devFrontBuildDate',
    },
    dateBuild: process.env.VUE_APP_DATE_BULID,
    devFrontBuildCommitText: {
      name: 'devFrontBuildCommit',
      translationPath: 'admin.devFrontBuildCommit',
    },
    commitBuild: process.env.VUE_APP_COMMIT_HASH.trim(),
  }),
  computed: {
    devFrontBuildDateValue() {
      if (this.dateBuild === undefined) {
        return this.$i18n.t('admin.noData');
      } else {
        return this.$dayjs(this.dateBuild).format('L, LTS');
      }
    },
    devFrontBuildCommitValue() {
      if (this.commitBuild === undefined) {
        return this.$i18n.t('admin.noData');
      } else {
        return this.commitBuild;
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>
